<th>{{ moduleName() | translate }}</th>
<td class="text-end">
  @if (moduleEnabled()) {
    <span class="badge bg-success">
      {{ 'tkey;admin.license.module.enabled.text' | translate }}
    </span>
  }
  @if (!moduleEnabled()) {
    <span class="badge bg-secondary">
      {{ 'tkey;admin.license.module.disabled.text' | translate }}
    </span>
  }
</td>
